import { Button } from '@/components/ui/button';
import { CloseButton } from '@/components/ui/close-button';
import { DialogActionTrigger, DialogBody, DialogCloseTrigger, DialogContent, DialogFooter, DialogRoot } from '@/components/ui/dialog';
import { DialogHeader, Flex, Icon, Text } from '@chakra-ui/react';
import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

interface PromptProps {
    open: boolean;
    message: ReactNode;
    onContinue: () => void;
    onCancel: () => void;
}

export function Prompt({ open, message, onContinue, onCancel }: PromptProps) {
    return (
        <DialogRoot role="alertdialog" open={open}>
            <DialogContent colorPalette="purple">
                <DialogHeader>
                    <Flex gap="1" alignItems="center">
                        <Icon size="sm" color="orange">
                            <AlertTriangle />
                        </Icon>
                        <Text>Warning</Text>
                    </Flex>
                </DialogHeader>
                <DialogBody>
                    <Text as="div">{message}</Text>
                </DialogBody>
                <DialogFooter>
                    <DialogActionTrigger asChild>
                        <Button variant="outline" size={{ base: 'xs', md: 'md' }} onClick={onCancel}>
                            Cancel
                        </Button>
                    </DialogActionTrigger>
                    <Button colorPalette="purple" size={{ base: 'xs', md: 'md' }} onClick={onContinue}>
                        Continue
                    </Button>
                </DialogFooter>
                <DialogCloseTrigger asChild onClick={onCancel}>
                    <CloseButton size="sm" />
                </DialogCloseTrigger>
            </DialogContent>
        </DialogRoot>
    );
}
